import { styled } from '@linaria/react';

import { FadeInImage } from '~shared/ui/atoms';

export const FadeInImageStyled = styled(FadeInImage)<{ blurred?: boolean }>`
	overflow: hidden;
	filter: ${({ blurred }) => (blurred ? 'blur(8px)' : 'none')};
`;
